export default __webpack_public_path__ + "static/media/rinjani.c076c46a.jpg";